import React from 'react'
import { conditionalWidth } from '../utils/useful'

class BottomSheet extends React.Component {
    state = {
        stage: 0,
        sideOpen: this.props.sideOpen ?? false
    }

    open = () => {
        this.setState({ sideOpen: true })
    }

    close = () => {
        this.setState({ sideOpen: false })


        setTimeout(() => {
            if (this.props.onClose) {
                this.props.onClose()
            }
        }, 500);


    }


    render() {


        return (
            <div className='w-100'>

                {!this.props.hideOverlay && (
                    <div onClick={() => { this.close() }} className={'position-fixed top-0 left-0 w-100 h-100 fadein br-10 ' + (this.state.sideOpen ? '' : 'd-none')} style={{ zIndex: 10, backgroundColor: '#10101080' }}>

                    </div>
                )}


                <div className={"bottomSheet  " + (this.state.sideOpen ? ' overflowAnimation' : 'close')} style={{ zIndex: 20, width: '100%' }}>
                    <div className='bottomSheet-content  h-100   ' style={{ backgroundColor: '#fff' }} >
                        {!this.props.hideHandle && (
                            <div className='flexcc pt-2 position-sticky top-0' style={{}}>
                                <div onClick={() => { this.close() }} className='br-20' style={{ backgroundColor: '#00000020', width: 40, height: 10 }}>
                                </div>
                            </div>
                        )}
                        {this.props.children}

                        {/* <button className={"close-hide sideHandler blur-back flexcc "} onClick={this.closeSidebar}>
                            <img src="/images/next-2.png" width="20px" alt="" />
                        </button> */}

                    </div>
                </div>
            </div>

        )

    }
}

export default (BottomSheet);